import styled, { css } from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import type { ICustomDotsStyles } from '@r1-frontend/ui-react/components/NukaCarousel/DefaultDots/styled';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { useProgressiveImage } from '~/src/helpers/hooks/useProgressiveImage';

type TImgBlock = {
    webpImg?: string,
    pngImg?: string,
}

const backgroundColorCart = '#222939';

export const SWideContainer = styled(WideContainer)`
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    @media (max-width: ${wideBreakpoints.mobile}) {
        padding: 0 24px;
    }
`;

export const CartWrapper = styled.div`
    width: 100%;
    background-color: ${backgroundColorCart};
`;

export const SWideContainerHeader = styled.div<TImgBlock>`
    overflow-x: hidden;
    ${(props) => (props.pngImg || props.webpImg) && css`
        background-image: url('${useProgressiveImage(props.webpImg, { hasTimeout: true, timeoutDelay: 1 }, props.pngImg)}');
        background-repeat: no-repeat;
        height: 100%;
        width: 100%;
        color: ${COLORS.white};
        background-position: right 29% bottom 71%;
        background-size: 50%;

        @media (max-width: ${wideBreakpoints.sDesktop}) {
            background-position: right 20% bottom 68%;
        }

        @media (max-width: ${wideBreakpoints.laptop}) {
            background-position: right 5% bottom 73%;
        };

        @media (max-width: ${wideBreakpoints.tablet}) {
            background-position: right 2% bottom 84%;
        };

        @media (max-width: ${wideBreakpoints.mobile}) {
            background-position: right 2% bottom 82%;
            background-size: 100%;
        };
    `};
`;

export const BlockWrapper = styled.div`
    width: 100%;
    flex-direction: column;
    margin: 64px 0;
`;

export const WrapperMain = styled.div`
    background: #141924;
    width: 100%;
    justify-content: center;
`;

export const WrapperMainGray = styled.div`
    background: #222939;
    width: 100%;
    justify-content: center;
`;

export const BlockTitle = styled.h2`
    ${FONTS.H2};
    margin-bottom: 32px;
    color: ${COLORS.white};

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.H3};
        margin-bottom: 24px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin-bottom: 32px;
    }

    @media (max-width: ${wideBreakpoints.sMobile}) {
        max-width: 95%;
    }
`;

export const customDotsStyles: ICustomDotsStyles = {
    dot: {
        background: COLORS.GRAY_S,
        opacity: 1,
    },
    activeDot: {
        background: COLORS.GRAY_XL,
    },
};
